import React from 'react'
import styled from 'styled-components'

const ContactUs = (props) => {
  return (
    <div {...props}></div>
  )
}

export default ContactUs